// extracted by mini-css-extract-plugin
export default {"ReadingTextSection":"ReadingText_ReadingTextSection__hcYaJ","readingText":"ReadingText_readingText__BHJXg"};